import clsx from 'clsx'
import { format, isSameDay, parseISO } from 'date-fns'
import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState
} from 'react'
import { useHistory, useParams } from 'react-router-dom'

import Avatar from '@material-ui/core/Avatar'
import Badge from '@material-ui/core/Badge'
import Box from '@material-ui/core/Box'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

import { Chip, Tooltip } from '@material-ui/core'
import { toast } from 'react-toastify'
import { v4 as uuidv4 } from 'uuid'
import { AuthContext } from '../../context/Auth/AuthContext'
import { TicketsContext } from '../../context/Tickets/TicketsContext'
import toastError from '../../errors/toastError'
import api from '../../services/api'

import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import { getInitials } from '../../helpers/getInitials'
import useClosingReasonSettings from '../../hooks/useClosingReasonSettings'
import { getTicketProtocol } from '../../utils/formatAudioDownloadName'
import ClosingReasonModal from '../ClosingReasonModal'
import TicketReportPreviewModal from '../TicketReportPreviewModal'

import {
  Bot,
  ThumbsUp,
  Volume2,
  VolumeOff
} from 'lucide-react'
import { useStyles } from './style'

import ContactTags from '../ContactTags'
import { getTextColor } from '../TagModal/color'

const TicketListItemCustom = ({
  ticket,
  itemSize,
  showReportDetails,
  setTabOpen,
  groupActionButtons
}) => {
  const classes = useStyles()
  const history = useHistory()
  const [ticketUser, setTicketUser] = useState(null)
  const [, setWhatsAppName] = useState(null)

  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false)
  const [closingReasonModalOpen, setClosingReasonModalOpen] = useState(false)
  const { ticketId: routeTicketId } = useParams()

  const isMounted = useRef(true)

  const { setCurrentTicket } = useContext(TicketsContext)
  const { user } = useContext(AuthContext)
  const { shouldRequireClosingReason, } =
    useClosingReasonSettings()

  const [, forceUpdate] = useReducer(state => state + 1, 0)

  const statusLabel = (() => {
    if (ticket.status === 'open') return 'Aberto'
    if (ticket.status === 'closed') return 'Fechado'
    if (ticket.status === 'pending') return 'Pendente'
    return ticket.status
  })()

  const formatDate = value => {
    if (!value) return '-'
    try {
      return format(parseISO(value), 'dd/MM/yy HH:mm')
    } catch {
      return '-'
    }
  }

  useEffect(() => {
    isMounted.current = true
    if (ticket.userId && ticket.user) {
      setTicketUser(ticket.user.name.substring(0, 15))
    }

    if (ticket.whatsappId && ticket.whatsapp) {
      setWhatsAppName(ticket.whatsapp.name)
    }

    return () => {
      isMounted.current = false
    }
  }, [ticket])

  const handleCloseTicket = async (id, closingReasonId = null) => {
    try {
      const updateData = {
        status: 'closed',
        justClose: true,
        userId: user?.id
      }

      if (closingReasonId) {
        updateData.closingReasonId = closingReasonId
      }

      await api.put(`/tickets/${id}`, updateData)
    } catch (err) {
      console.error('Error closing ticket', id, err)
      toastError(err)
    }
    history.push(`/tickets/`)
  }

  // const handleOpenClosingReasonModal = async () => {
  //   // Verificar se o usuário atual é o atendente principal
  //   const isMainAttendant = ticket.userId === user?.id
  //   const isAdmin = (user?.profile || '').toLowerCase() === 'admin'
  //   const ticketQueueId = Number(ticket?.queueId)
  //   const userQueueIds = Array.isArray(user?.queues)
  //     ? user.queues.map(queue => Number(queue.id))
  //     : []
  //   const userVisibleDepartmentIds = Array.isArray(user?.visibleDepartmentIds)
  //     ? user.visibleDepartmentIds.map(id => Number(id))
  //     : []
  //   const hasQueueRestriction =
  //     userQueueIds.length > 0 || userVisibleDepartmentIds.length > 0
  //   const hasAccessToTicketQueue =
  //     !ticketQueueId ||
  //     !hasQueueRestriction ||
  //     userQueueIds.includes(ticketQueueId) ||
  //     userVisibleDepartmentIds.includes(ticketQueueId)
  //   const shouldAskTransferToAdmin = isAdmin && hasAccessToTicketQueue

  //   // Se o usuário NÃO é o atendente principal
  //   if (!isMainAttendant) {
  //     if (shouldAskTransferToAdmin) {
  //       const shouldTransferToCurrentUser = window.confirm(
  //         'Este atendimento não está com um administrador. Deseja transferir este atendimento para você?'
  //       )

  //       if (shouldTransferToCurrentUser) {
  //         try {
  //           await api.put(`/tickets/${ticket.id}`, {
  //             status: ticket.status || 'open',
  //             userId: user?.id
  //           })
  //           history.push(`/tickets/${ticket.uuid}`)
  //         } catch (err) {
  //           toastError(err)
  //         }
  //       }
  //       return
  //     }

  //     // Para não-principal sem regra de transferência, apenas desvincular
  //     try {
  //       await api.delete(`/ticket-attendants/${ticket.id}/${user?.id}`)
  //       history.push('/tickets/')
  //     } catch (err) {
  //       toastError(err)
  //     }
  //     return
  //   }

  //   // Se é o atendente principal, seguir o fluxo normal de finalização
  //   if (
  //     shouldRequireClosingReason(ticket) &&
  //     (await hasClosingReasonsForTicket(ticket))
  //   ) {
  //     setClosingReasonModalOpen(true)
  //   } else {
  //     // Se não requer motivo da finalização, fechar diretamente
  //     handleCloseTicket(ticket.id, null)
  //   }
  // }

  const handleClosingReasonConfirm = closingReasonId => {
    setClosingReasonModalOpen(false)
    handleCloseTicket(ticket.id, closingReasonId)
  }

  const handleClosingReasonCancel = () => {
    setClosingReasonModalOpen(false)
  }

  const handleAcceptTicket = async id => {
    try {
      await api.put(`/tickets/${id}`, {
        status: 'open',
        userId: user?.id
      })
    } catch (err) {
      console.error('Error accepting ticket', id, err)
      toastError(err)
    }

    history.push(`/tickets/${ticket.uuid}`)
    setTabOpen('open')
  }

  const handleMuteTicket = async () => {
    if (!ticket.contact?.id) {
      toastError('Não foi possível identificar o contato do grupo.')
      return
    }

    const isMuted = (ticket.contact?.silencedFor?.users || []).includes(user.id)
    const payload = { silence: !isMuted }

    try {
      const { data } = await api.post(
        `/contacts/${ticket.contact.id}/silence`,
        payload
      )
      // Atualiza o ticket local com os novos dados do contato
      if (data.contact && data.contact.silencedFor) {
        ticket.contact.silencedFor = data.contact.silencedFor
      }

      // Exibe mensagem de sucesso baseada na ação
      if (!isMuted) {
        toast.success(`Notificações silenciadas com sucesso!`)
      } else {
        toast.success(`Notificações ativadas com sucesso!`)
      }

      // Força uma atualização do componente para refletir a mudança
      if (isMounted.current) {
        forceUpdate()
      }
    } catch (err) {
      console.error(
        '[FRONTEND DEBUG] Erro ao tentar silenciar:',
        err.response?.data || err
      )
      toastError(
        'Erro ao alterar configuração de notificação. Tente novamente.'
      )
    }
  }

  const handleSelectTicket = ticket => {
    const code = uuidv4()
    const { id, uuid } = ticket
    setCurrentTicket({ id, uuid, code })
  }

  useEffect(() => {
    if (ticket.unreadMessages !== undefined) {
      const timer = setTimeout(() => {
        if (isMounted.current) {
          forceUpdate()
        }
      }, 50)

      return () => clearTimeout(timer)
    }
  }, [ticket.unreadMessages])

  const isMuted = (ticket.contact?.silencedFor?.users || []).includes(user.id)

  return (
    <React.Fragment key={ticket.id}>
      <TicketReportPreviewModal
        open={openTicketMessageDialog}
        onClose={() => {
          setOpenTicketMessageDialog(false)
        }}
        ticketId={ticket.id}
      />
      {shouldRequireClosingReason(ticket) && (
        <ClosingReasonModal
          open={closingReasonModalOpen}
          onClose={handleClosingReasonCancel}
          onConfirm={handleClosingReasonConfirm}
          ticket={ticket}
        />
      )}
      {showReportDetails ? (
        <TableRow
          hover
          onClick={() => setOpenTicketMessageDialog(true)}
          selected={routeTicketId && +routeTicketId === ticket.id}
          className={classes.reportTableRow}
        >
          <TableCell className={classes.reportTableCell}>
            {getTicketProtocol(ticket)}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {ticket?.contact?.name || '-'}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {ticket?.whatsapp?.name || '-'}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {ticket.queue?.name || 'Sem Departamento'}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {statusLabel}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {ticket.user?.name || 'Sem usuário'}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {(() => {
              const allTags = [
                ...(ticket.tags || []),
                ...(ticket.contact?.tags || [])
              ].filter((tag, index, self) =>
                index === self.findIndex(t => t.id === tag.id)
              )
              const tagsText = allTags.map(tag => tag.name).join(', ') || '-'
              const coloredTagsContent = allTags.length > 0 ? (
                <span className={classes.reportTagsCell}>
                  {allTags.map(tag => (
                    <Chip
                      key={tag.id}
                      label={tag.name}
                      size="small"
                      style={{
                        backgroundColor: tag.color || '#eee',
                        border: `1px solid ${getTextColor(tag.color)}`,
                        borderRadius: '4px',
                        color: getTextColor(tag.color),
                        height: '20px',
                        fontSize: '11px',
                        textTransform: 'uppercase',
                        margin: '1px 2px 1px 0'
                      }}
                    />
                  ))}
                </span>
              ) : (
                '-'
              )
              return (
                <Tooltip title={coloredTagsContent} arrow>
                  <span>{tagsText}</span>
                </Tooltip>
              )
            })()}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {formatDate(ticket.createdAt)}
          </TableCell>
          <TableCell className={classes.reportTableCell}>
            {formatDate(ticket.finishedAt)}
          </TableCell>
        </TableRow>
      ) : (
        <ListItem
          button
          onClick={e => {
            if ((groupActionButtons || !ticket.isGroup) && ticket.status === '') {
              return
            }
            handleSelectTicket(ticket)
          }}
          selected={routeTicketId && +routeTicketId === ticket.id}
          className={clsx(classes.ticketBoxMessage, {
            [classes[`ticketBoxMessage${itemSize}`]]: itemSize,
            [classes.pendingTicket]: ticket.status === 'pending'
          })}
        >
          <ListItemAvatar className={classes.ticketBoxAvatar}>
            <div className={classes.ticketAvatarWrapper}>
              <Avatar
                src={ticket?.contact?.profilePicUrl}
                className={classes.ticketAvatar}
                imgProps={{
                  onError: e => {
                    e.target.onerror = null
                    e.target.src = ''
                  }
                }}
              >
                {getInitials(ticket?.contact?.name || '')}
              </Avatar>

              {ticket.channel === 'whatsapp' && (
                <WhatsAppIcon
                  style={{ color: 'white' }}
                  className={classes.ticketAvatarIcon}
                />
              )}
            </div>
          </ListItemAvatar>

          <ListItemText
            className={classes.contactNameWrapper}
            disableTypography
            primary={
              <div className={classes.contactBox}>
                <div className={classes.contactBoxLastMessage}>
                  <div className={classes.contactBoxConnectionAndUser}>
                    <div className={classes.contactHeader}>
                      <Typography noWrap className={classes.contactName}>
                        {ticket?.contact?.name}
                      </Typography>
                    </div>
                    <Typography
                      className={classes.contactWhatsappName}
                      noWrap
                      component="span"
                      variant="body2"
                      color="textSecondary"
                    >
                      <span>{ticket?.whatsapp?.name}</span>
                    </Typography>
                    <Typography
                      className={classes.contactLastMessage}
                      noWrap
                      component="span"
                      variant="body2"
                      color="textSecondary"
                    >
                      <span>{ticket.queue?.name || 'Sem Departamento'}</span>
                    </Typography>
                    {showReportDetails && (
                      <Typography
                        className={classes.reportTicketDetails}
                        noWrap
                        component="span"
                        variant="body2"
                        color="textSecondary"
                      >
                        <span>
                          Status: {ticket.status === 'open'
                            ? 'Aberto'
                            : ticket.status === 'closed'
                              ? 'Fechado'
                              : 'Pendente'}
                        </span>
                        <span>
                          Último usuário: {ticket.user?.name || 'Sem usuário'}
                        </span>
                      </Typography>
                    )}
                  </div>
                  <div className={classes.boxInfo}>
                    {ticket.lastMessage && (
                      <div className={classes.boxLastMessage}>
                        <Typography
                          className={classes.lastMessageTime}
                          component="span"
                          variant="body2"
                          color="textSecondary"
                        >
                          {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                            <>{format(parseISO(ticket.updatedAt), 'HH:mm')}</>
                          ) : (
                            <>
                              {format(parseISO(ticket.updatedAt), 'dd/MM/yy')}
                            </>
                          )}
                        </Typography>

                        {ticketUser && !ticket.isGroup && (
                          <Typography
                            className={classes.boxAttendant}
                            noWrap
                            component="span"
                            variant="body2"
                            color="textSecondary"
                          >
                            <span>{ticketUser}</span>
                          </Typography>
                        )}

                        <Badge
                          className={classes.newMessagesCount}
                          badgeContent={
                            ticket.unreadMessages ? ticket.unreadMessages : null
                          }
                          overlap="rectangular"
                          classes={{
                            badge: classes.badgeStyle
                          }}
                        />
                      </div>
                    )}
                    {ticket.status === 'pending' &&
                      !ticket.isGroup &&
                      !ticket.chatbot && (
                        <Tooltip title="Aceitar Conversa" arrow>
                          <ThumbsUp
                            className={classes.buttonAcceptTicket}
                            onClick={() => {
                              handleAcceptTicket(ticket.id)
                            }}
                            size={20}
                          />
                        </Tooltip>
                      )}

                    {/* Ícone do chatbot */}
                    {ticket.chatbot && (
                      <Tooltip
                        title="Chatbot"
                        className={classes.botIconWrapper}
                        arrow
                      >
                        <Bot size={24} className={classes.botIcon} />
                      </Tooltip>
                    )}

                    {/* icone de silenciar */}
                    {ticket.isGroup && (
                      <Tooltip
                        arrow
                        title={
                          isMuted ? 'Ativar notificação' : 'Silenciar notificação'
                        }
                      >
                        {isMuted ? (
                          <VolumeOff
                            className={classes.iconNotification}
                            onClick={handleMuteTicket}
                            size={20}
                          />
                        ) : (
                          <Volume2
                            className={classes.iconNotification}
                            onClick={handleMuteTicket}
                            size={20}
                          />
                        )}
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            }
            secondary={
              <Box className={classes.ticketBadge}>
                <ContactTags
                  contact={ticket.contact}
                  ticket={ticket}
                  disabledAddTags={true}
                  showAllTypes={true}
                />

                {/* Badge para tickets pendentes */}
                {ticket.status === 'pending' && ticket.queue?.name !== null && (
                  <Badge className={classes.Radiusdot} overlap="rectangular" />
                )}
              </Box>
            }
          />
        </ListItem>
      )}
    </React.Fragment>
  )
}

export default TicketListItemCustom